"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'DetailInfo',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
};